import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StatusRequest } from 'src/app/models/requests';
import { RequestStatusService } from './requeststatus.service';
import { PlatformHub } from 'src/app/platform.hub';
import { RequestStatuses } from 'src/app/constants/status.enum';
import { PillBadgeStatusEnum } from 'src/app/constants/badge-status.enum';
import { TranslateService } from '@ngx-translate/core';
import { StringHelper } from 'src/app/directives/string-helper';

@Component({
  templateUrl: './requeststatus.page.html',
  styleUrls: ['./requeststatus.page.css']
})
export class RequeststatusPage implements OnDestroy, OnInit {
  requestGuid: string = "";
  request: StatusRequest = {} as StatusRequest;
  currentTab: string = "Request";
  statusIndicator!: string;
  statusBadge!: string;
  stringHelper = new StringHelper();

  private requestSubscription: Subscription;
  private loadingSubscription!: Subscription;

  constructor(private requestStatusService: RequestStatusService, private platformHub: PlatformHub, private translateService: TranslateService) {
    let urlsplit = new URL(window.location.href).pathname.split("/");
    this.requestGuid = urlsplit[2];
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      if (Object.keys(request).length === 0) return;
      this.request = request;
      this.getStatusIndicator();
    });
  }
  ngOnInit(): void {
    this.loadingSubscription = this.platformHub.hasStartedSubject.subscribe(hasStarted => {
      if (hasStarted) {
        this.requestStatusService.setSelectedRequestId(this.requestGuid);

      }
    });
  }

  ngOnDestroy(): void {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
    // RESET
    this.requestStatusService.setSelectedRequestId("");
    this.requestSubscription.unsubscribe();
  }

  public get displayWithdrawnHeader(): boolean {
    return this.request && this.request.isWithdrawn;
  }
  public get displayRejectionHeader(): boolean {
    return this.request && this.request.isRejected;
  }
  public getActiveTab(event: any) {
    this.currentTab = event;
  }

  getStatusIndicator() {
    let primaryStatuses: string[] = RequestStatuses.PrimaryStatuses;
    let warningStatuses: string[] = RequestStatuses.WarningStatuses;
    let successStatuses: string[] = RequestStatuses.SuccessStatuses;
    let errorStatuses: string[] = RequestStatuses.ErrorStatuses;

    if (errorStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Danger;
    }
    if (successStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Success;
    }

    if (primaryStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Primary;
    } else if (warningStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Warning;
    } else if (successStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Success;
    } else if (errorStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Danger;
    } else {
      this.statusIndicator = PillBadgeStatusEnum.Warning;
    }

    if (this.statusIndicator === PillBadgeStatusEnum.Warning) {
      let countOfTotalActions = this.request.actors.length;
      let countOfTotalActionsDone = this.request.actors.filter((actor) => actor.signingDate).length;
      this.statusBadge = this.translateService.instant("Status.Sent")+" "+countOfTotalActionsDone+"/"+countOfTotalActions+"";
    } else if (this.statusIndicator === PillBadgeStatusEnum.Danger) {
      this.statusBadge = this.translateService.instant("Status."+this.request.status);
    } else {
      this.statusBadge = this.translateService.instant("Status.Completed");
    }
  }

}
